import { isLeadProduct, type LeadProduct } from '@/lib/leads/leadEventSchema';

interface LogContactClickPayload {
  profileId: string;
  product: LeadProduct;
  source: string;
  viewerId?: string | null;
}

/**
 * Forward-only contact telemetry. Fires a `contact_click` at the lead-event
 * endpoint without ever blocking the visitor's contact action.
 *
 * History cannot be rebuilt, so the funnel's Contact stage only reflects clicks
 * that happen after this logging ships.
 */
export function logContactClick(payload: LogContactClickPayload): void {
  if (!payload.profileId || !isLeadProduct(payload.product)) return;
  try {
    void fetch('/api/telemetry/lead-event', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({
        profileId: payload.profileId,
        product: payload.product,
        eventType: 'contact_click',
        source: payload.source,
        viewerId: payload.viewerId ?? null,
      }),
    }).catch(() => {});
  } catch {
    // Telemetry must never block the contact action.
  }
}
